import { baseApi } from 'api'
import { ApiResponse } from 'helpers/types'
import { UserDocumentTypeListResponse, UserInfo, UserInfoResponse } from 'schema'

import { TUserDocumentType } from '../types'

export const profileApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getUserDocumentTypes: build.query<TUserDocumentType[], void>({
      query: () => ({
        url: 'user-document-type',
        method: 'GET'
      }),
      transformResponse: (response: ApiResponse<UserDocumentTypeListResponse>) => response.data.userDocumentType,
      forceRefetch: () => true
    })
  }),
  overrideExisting: false
})

export const { useGetUserDocumentTypesQuery } = profileApi
